import type { PermissionACRUD, PermissionScope } from "@scayla/api-client-fetch";

/**
 * The user's permission on a settings entity in one organization. The scope lists the entity once
 * per grant (each role, the admin membership), in no guaranteed order, so the grants are merged:
 * a flag is set when any of them sets it. Every flag is false when the organization or entity is
 * missing.
 */
export function mergeOrgEntityPermissions(
  scope: PermissionScope[] | null | undefined,
  orgId: string | null | undefined,
  entityKey: string,
): PermissionACRUD {
  const merged: PermissionACRUD = { active: false, create: false, read: false, edit: false, delete: false };
  if (!orgId || !scope) return merged;

  const orgScope = scope.find((s) => s.organization.id === orgId);
  for (const { entity, permission } of orgScope?.entities ?? []) {
    if (entity.table_name !== entityKey) continue;
    merged.active ||= permission.active;
    merged.create ||= permission.create;
    merged.read ||= permission.read;
    merged.edit ||= permission.edit;
    merged.delete ||= permission.delete;
  }
  return merged;
}
